module.exports = __webpack_public_path__ + "static/img/event12.fe51aff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event12.png
// module id = Hq3/
// module chunks = 1